import { render, staticRenderFns } from "./SiteVersionComment.vue?vue&type=template&id=ab9b199c&scoped=true&"
import script from "./SiteVersionComment.vue?vue&type=script&lang=js&"
export * from "./SiteVersionComment.vue?vue&type=script&lang=js&"
import style0 from "./SiteVersionComment.vue?vue&type=style&index=0&id=ab9b199c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9b199c",
  null
  
)

export default component.exports